module.exports = __webpack_public_path__ + "img/cyyc3.f5d77b6e.jpg";